const handlebars = require('handlebars');
const merge = require('deepmerge');

module.exports = class ErrorMessageCompiler {
  constructor(errorMessage, data) {
    this._errorMessage = merge({}, errorMessage);
    this._data = data;
  }

  compile() {
    let result = {
      message: this._errorMessage.message
    };

    if (this._errorMessage.variable) {
      result = this._compileWithVar();
    }

    this._errorMessage.message = result.message;
    this._errorMessage.data = result.data;
    return this._errorMessage;
  }

  _compileWithVar() {
    const template = handlebars.compile(this._errorMessage.message);
    let variables = this._errorMessage.variable;
    const data = {};

    if (!Array.isArray(variables)) {
      variables = [variables];
    }

    variables.forEach(variable => {
      const value = this._getValue(variable);
      data[variable] = value;
    });

    if (JSON.stringify(data) === JSON.stringify({})) {
      return {
        message: this._errorMessage.message
      };
    }

    return {
      message: template(data),
      data
    };
  }

  _getValue(variable) {
    const SUBFIELD_SIGN = '_';
    const field = this._errorMessage.field;

    if (this._data[variable]) {
      return this._data[variable];
    }

    if (field.includes(SUBFIELD_SIGN) && (!this._data[field] || !this._data[field][variable])) {
      const parts = field.split(SUBFIELD_SIGN);
      const outField = parts[0];
      const subField = parts[1];
      if (!this._data[outField] || !this._data[outField][subField]) {
        return undefined;
      }
      return this._data[outField][subField][variable];
    }

    if (this._data[field]) {
      return this._data[field][variable];
    }

    return undefined;
  }
};
